import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function PdfView(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M18 5a3 3 0 00-3-3h-5c-.25 0-.48.092-.655.244L2.353 8.237A.998.998 0 002 9v10a3 3 0 003 3h10a3 3 0 003-3 1 1 0 10-2 0 1 1 0 01-1 1H5a1 1 0 01-1-1v-9h5a2 2 0 002-2V4h4a1 1 0 011 1v2a1 1 0 102 0V5zM9 8H5.703L9 5.174V8zm3.737 5.006L12.731 13l.007-.007c.26-.288.633-.672 1.085-1.053.932-.787 2.07-1.457 3.177-1.457 1.107 0 2.248.67 3.183 1.458.453.381.827.764 1.088 1.053l.006.006-.005.006c-.261.288-.636.67-1.089 1.05-.934.786-2.076 1.455-3.183 1.455-1.107 0-2.246-.669-3.178-1.454-.452-.38-.825-.762-1.085-1.05zm9.646-1.02c.163.18.325.365.473.558.227.296.184.678-.037.96a12.887 12.887 0 01-1.67 1.701c-1.006.844-2.495 1.805-4.149 1.805s-3.141-.961-4.144-1.806a12.837 12.837 0 01-1.574-1.587 5.982 5.982 0 01-.128-.16l-.001-.002a.751.751 0 010-.91c.148-.194.308-.377.471-.558.293-.325.715-.758 1.231-1.194 1.003-.847 2.49-1.81 4.145-1.81 1.655 0 3.144.963 4.149 1.81.517.435.94.869 1.234 1.193zM18 13a1 1 0 11-2 0 1 1 0 012 0z",
    clipRule: "evenodd"
  }));
}

export default PdfView;